var render = function render(){var _vm=this,_c=_vm._self._c;return _c(_vm.getComponentName,{tag:"component",attrs:{"widgetId":_vm.widgetDetails.widgetId,"isExpandedView":_vm.isExpandedView,"data":_vm.widgetDetails.data,"expandedVwTxt":_vm.widgetDetails.expandedVwTxt,"mode":_vm.mode},on:{"showExpandedView":function($event){return _vm.$emit(`showExpandedView`)}}})
}
var staticRenderFns = []

export { render, staticRenderFns }